import React from 'react';

const GreyedOutLock = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1555_30877)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.6274 54.6274C67.1242 42.1306 67.1242 21.8694 54.6274 9.37258C42.1306 -3.12419 21.8694 -3.12419 9.37258 9.37258C-3.12419 21.8694 -3.12419 42.1306 9.37258 54.6274C21.8694 67.1242 42.1306 67.1242 54.6274 54.6274ZM12.201 51.799C23.1357 62.7337 40.8643 62.7337 51.799 51.799C62.7337 40.8643 62.7337 23.1357 51.799 12.201C40.8643 1.26633 23.1357 1.26633 12.201 12.201C1.26633 23.1357 1.26633 40.8643 12.201 51.799Z"
        fill="#BABCBF"
      />
      <path
        d="M27 29V24C27 21.2386 29.2386 19 32 19C34.7614 19 37 21.2386 37 24V29"
        stroke="#BABCBF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 34.4C22 32.1598 22 31.0397 22.436 30.184C22.8195 29.4314 23.4314 28.8195 24.184 28.436C25.0397 28 26.1598 28 28.4 28H35.6C37.8402 28 38.9603 28 39.816 28.436C40.5686 28.8195 41.1805 29.4314 41.564 30.184C42 31.0397 42 32.1598 42 34.4V35.4C42 38.7603 42 40.4405 41.346 41.7239C40.7708 42.8529 39.8529 43.7708 38.7239 44.346C37.4405 45 35.7603 45 32.4 45H31.6C28.2397 45 26.5595 45 25.2761 44.346C24.1471 43.7708 23.2292 42.8529 22.654 41.7239C22 40.4405 22 38.7603 22 35.4V34.4Z"
        fill="#BABCBF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1555_30877">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GreyedOutLock;
